export default "__VITE_ASSET__BmPsaYzl__"